// extracted by css-extract-rspack-plugin
export default {"tip":"tip-rk9EMn","tip__desc":"tip__desc-Wo9EgF","tipDesc":"tip__desc-Wo9EgF"};